const state = {
    group: {
        aData: [], // 企业分组
        hashWithId: {},
        hashWithLetter: {},
        allSnames: ''
    }

}

const mutations = {
    setGroup(state, group) {
        state.group = group
    }
}

const actions = {
    setGroup({ commit }, group) {
        commit('setGroup', group)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}